import styled from 'styled-components';

export const FiltersWrapper = styled.div`
display: flex;
align-items: baseline;
flex-wrap: wrap;
gap: 10px;
`